enum ObjectType {
  Area = 'area',
  Trail = 'trail'
}

export default ObjectType;
